import { render, staticRenderFns } from "./LbaInputFile.vue?vue&type=template&id=ca65d0b0"
import script from "./LbaInputFile.vue?vue&type=script&lang=js"
export * from "./LbaInputFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports